import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FaIconModule } from '@libraries/fa';
import { GoogleMapsAddressModule } from '@libraries/google-maps';
import { FullNamePipe, RoundKPipe, RoundUpPipe } from './pipes';

@NgModule({
  imports: [
    CommonModule,
    FaIconModule,
    FormsModule,
    GoogleMapsAddressModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    FullNamePipe,
    RoundKPipe,
    RoundUpPipe,
  ],
  declarations: [],
  exports: [FullNamePipe, RoundKPipe, RoundUpPipe],
})
export class UiModule {
  static forRoot(): ModuleWithProviders<UiModule> {
    return {
      ngModule: UiModule,
      providers: [],
    };
  }
}
